module.exports = __webpack_public_path__ + "firefox_logo-only.15d8e675.svg";